<p-toast></p-toast>
<div class="mw-100" style="background-color: white; height: 100%;">
  <app-navbar></app-navbar>
  <div class="row">
    <div class="container">
      <div>
        <h2 style="text-align: left; margin-left: 20px;" class="title">{{'SETTINGS' | translate}}</h2>
        <div class="items" style="margin-left: 40px;">
          <h5 class="sub-title">{{'STATUS_BAR' | translate}}</h5>
          <div class="card customCard">
            <p-table responsiveLayout="stack" [value]="items" breakpoint="1050px" 
            [style]="customTableStyle">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th class="tableHeading" [style.width]="'50%'">{{'NAME_SETTINGS' | translate}}</th>
                  <th class="tableHeading" [style.width]="'25%'">{{'EDIT' | translate}}</th>
                  <th class="tableHeading" [style.width]="'25%'">{{'HIDE' | translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr [ngClass]="getItemClass(item)">
                  <td  [style.width]="'50%'">
                    <ng-container *ngIf="!editingStates[item.id]; else editInput">
                      {{ item.nombre }}
                    </ng-container>
                    <ng-template #editInput>
                      <input type="text" [(ngModel)]="nameToSave" placeholder="{{ 'NAME_PLACEHOLDER' | translate}}" class="edit-input"
                        [ngClass]="{ 'invalid': !isValidName() }">
                      <div *ngIf="!isValidName()" class="invalid-feedback">
                        <span *ngIf="!nameToSave || nameToSave.trim() === ''">{{ 'FIELD_EMPTY' | translate}}</span>
                        <span *ngIf="nameToSave && nameToSave.length > 15">{{ 'FIELD_CHARACTERS' | translate}}</span>
                      </div>
                    </ng-template>
                  </td>
                  <td [style.width]="'25%'">
                    <ng-container *ngIf="!editingStates[item.id]; else editButtons">
                      <button type="button" pButton icon="pi pi-user-edit" class="p-button-text icnCust"
                        (click)="editItem(item.id, item.nombre)" [disabled]="item.nombre === 'Asignado'"></button>
                    </ng-container>
                    <ng-template #editButtons>
                      <button type="button" pButton icon="pi pi-check" class="p-button-text icnCust"
                        (click)="saveChanges(item.id)" [disabled]="!isValidName()"></button>
                      <button type="button" pButton icon="pi pi-times" class="p-button-text icnCust"
                        (click)="cancelEdit(item.id)"></button>
                    </ng-template>
                  </td>
                  <td [style.width]="'25%'">
                    <p-inputSwitch [(ngModel)]="item.mostrar" (ngModelChange)="updateVisible(item.id)" [disabled]="item.nombre === 'Asignado'"></p-inputSwitch>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
